import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const PHONE = "6372045675";
export const WHATSAPP_URL = `https://wa.me/91${PHONE}?text=${encodeURIComponent(
  "Hi Amyee Travels, I would like to book a taxi."
)}`;
export const TEL_URL = `tel:+91${PHONE}`;
